import { useActor } from '@xstate/react';
import { PasswordMachineActor } from '../../../machines/RedeemInvitation/PasswordMachine';
import { PasswordView } from './PasswordView';

export function PasswordController({ actor }: { actor: PasswordMachineActor }) {
  const [state, send] = useActor(actor);

  return <PasswordView state={state} send={send} />;
}
